// Grab all the Firebase goodies we need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// Hey! Add more Firebase stuff here if you need it
// Check out: https://firebase.google.com/docs/web/setup#available-libraries

// Your app's special Firebase settings - keep these safe! 🔒
const firebaseConfig = {
  apiKey: "AIzaSyCCzHMxXPxdQ5OIWtmfjFYQB8ZXPwXyGVQ",
  authDomain: "chordbase-23845.firebaseapp.com",
  projectId: "chordbase-23845",
  storageBucket: "chordbase-23845.firebasestorage.app",
  messagingSenderId: "211189223824",
  appId: "1:211189223824:web:7d0d178b18174c4bc76315",
  measurementId: "G-C6LGQ4Y278"
};

// Fire up Firebase! 🚀
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Set up auth and database - we'll need these everywhere
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;